import { useStoreWithEqualityFn } from 'zustand/traditional'
import { AuthStore } from '@/scopes/auth/domain/types'
import { useAuthDependencies } from './dependencies'

export function useAuthStore<T>(
  selector: (state: AuthStore) => T,
  equalityFn?: (a: T, b: T) => boolean,
): T {
  const { store } = useAuthDependencies()
  if (!store) {
    throw new Error('store not provided')
  }

  return useStoreWithEqualityFn(store, selector, equalityFn)
}
